<footer>
  <div class="shell-container-row footer-content">
    <div>
      <label *ngIf="!customerSpace && version" class="version">
        {{ 'footer.version' | translate }}
        <span>{{ version }}</span>
      </label>
    </div>

    <ul *ngIf="customerSpace" class="links">
      <ng-container *ngIf="customerSpace.abacusMandator.abacusInstanceId || customerSpace.abacusMandator.abacusMandatorId">
        <li *appShowAuthorize="'APP_LINKS_ABACUS_READ'; options: { values: { customerSpaceId: customerSpace.id } }">
          <a href="{{ customerSpace.abacusMandator.myAbacusInboxUrl }}" target="_blank">{{ 'cockpit.links-widget.abacus' | translate }}</a>
        </li>
        <li *appShowAuthorize="'APP_LINKS_ABACUS_ERP_READ'; options: { values: { customerSpaceId: customerSpace.id } }">
          <a href="{{ customerSpace.abacusMandator.abacusErpUrl }}" target="_blank">{{ 'cockpit.links-widget.abacusErp' | translate }}</a>
        </li>
      </ng-container>
      <li *appShowAuthorize="'APP_LINKS_ABACUS_OBT_ERP_READ'; options: { values: { customerSpaceId: customerSpace.id } }">
        <a href="{{ customerSpace.abacusMandator.abacusObtErpUrl }}" target="_blank">
          {{ 'cockpit.links-widget.abacusObtErp' | translate }}
        </a>
      </li>
      <li *appShowAuthorize="'APP_LINKS_TICKET_PORTAL_READ'; options: { values: { customerSpaceId: customerSpace.id } }">
        <a href="https://ticket.obt.ch/" target="_blank">{{ 'cockpit.links-widget.ticketportal' | translate }}</a>
      </li>
      <li *appShowAuthorize="'APP_LINKS_OBT_WEBSITE_READ'; options: { values: { customerSpaceId: customerSpace.id } }">
        <a href="https://www.obt.ch/" target="_blank">{{ 'cockpit.links-widget.obtWebsite' | translate }}</a>
      </li>
    </ul>
  </div>
</footer>
